var h = Object.defineProperty;
var d = (s, t, e) => t in s ? h(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var r = (s, t, e) => (d(s, typeof t != "symbol" ? t + "" : t, e), e);
class o {
  constructor() {
    this.eventListener = {};
  }
  addEventListener(t, e) {
    return this.eventListener[t] = this.eventListener[t] || [], this.eventListener[t].push(e), this;
  }
  removeEventListener(t, e) {
    const n = this.eventListener[t];
    if (n) {
      let i;
      for (; (i = n.indexOf(e)) !== -1; )
        n.splice(i, 1);
    }
  }
  trigger(t, e) {
    e.type = t, (this.eventListener[t] || []).forEach((n) => {
      n(e);
    });
  }
}
const l = "v14";
class c extends o {
  constructor() {
    super(...arguments);
    r(this, "_handle");
    r(this, "_handleSetCallbacks", []);
  }
  _setHandle(e) {
    this._handle = e, this._handleSetCallbacks.forEach((n) => n(e)), this._handleSetCallbacks = [], Object.entries(this.eventListener).forEach(([n, i]) => {
      e.addEventListener(n, i);
    }), this.eventListener = {};
  }
  addEventListener(e, n) {
    return this._handle ? (this._handle.addEventListener(e, n), this) : super.addEventListener(e, n);
  }
  removeEventListener(e, n) {
    if (this._handle)
      return this._handle.removeEventListener(e, n), this;
    super.removeEventListener(e, n);
  }
  tearDown() {
    var e;
    this._handle ? (e = this._handle) == null || e.tearDown() : this._handleSetCallbacks.push(() => {
      this.tearDown();
    });
  }
}
const v = (s) => `v${(s || l).replace(/^v/, "")}`, L = {
  init(s) {
    const t = new c();
    return import(/* webpackIgnore: true */ s.sdkUrl || `https://sdk.onfido.com/${v(s.version)}/Onfido.js`).then((n) => {
      const { Onfido: i } = n;
      t._setHandle(i.init(s));
    }).catch((n) => {
      var i;
      t.trigger("error", { error: n }), (i = s.onError) == null || i.call(s, n);
    }), t;
  }
};
export {
  L as Onfido,
  v as prefixVersion
};
